// Generated by tools/item-dyes.py client from assets/source/commissioned/hero-kit/dyes.json and dye-ramps.json
// (docs/129 §8, docs/142): do not edit by hand.
// The hero's dyes (id 0 is the art as drawn) and, per worn piece that takes a dye, which of its colours dye and the
// dye shade (0 darkest … 3 lightest) each becomes (IA12, on the twelve dyes' mean lightness ladder, DY3).

export interface DyeRamp { id: number; key: string; name: string; ramp: readonly [string, string, string, string] }

export const DYES: readonly DyeRamp[] = [
  { id: 1, key: 'plum', name: 'Plum', ramp: ['50243e', '803e60', 'b36383', 'de96ab'] },
  { id: 2, key: 'olive', name: 'Olive', ramp: ['28390d', '575e1a', '818230', 'baba63'] },
  { id: 3, key: 'rust', name: 'Rust', ramp: ['621704', '8d3c18', 'c15d11', 'e29c65'] },
  { id: 4, key: 'sky', name: 'Sky', ramp: ['224a71', '3375a4', '55a2ce', '90ceeb'] },
  { id: 5, key: 'cream', name: 'Cream', ramp: ['5e564f', '968368', 'c8b594', 'ede1c0'] },
  { id: 6, key: 'slate', name: 'Slate', ramp: ['26324d', '535861', '718295', '9ab1c6'] },
  { id: 7, key: 'teal', name: 'Teal', ramp: ['003e44', '006669', '129390', '65c1b5'] },
  { id: 8, key: 'red', name: 'Red', ramp: ['650c1d', 'a9001a', 'e24a3f', 'f98b6f'] },
  { id: 9, key: 'blue', name: 'Blue', ramp: ['203068', '2e52a5', '427fd8', '76b3f1'] },
  { id: 10, key: 'green', name: 'Green', ramp: ['01421a', '006525', '40932c', '8fbf65'] },
  { id: 11, key: 'gold', name: 'Gold', ramp: ['6b4316', '9d6d1c', 'c9992f', 'e9c85e'] },
  { id: 12, key: 'violet', name: 'Violet', ramp: ['3a2862', '644395', '9169c4', 'bf9ce5'] },
];

export const ITEM_DYES: Readonly<Record<number, Readonly<Record<string, number>>>> = {
  900: { '31130c': 0, '530e0e': 1, '7f1818': 2, '9c2323': 3, 'ab2728': 3 },
  901: { '424242': 0, '515151': 1 },
  902: { '242016': 0, '474747': 1 },
  903: { 'a20402': 1 },
  906: { '271d0f': 0, '432b1c': 1, '4d3221': 2, '774013': 3, '7d5119': 3 },
  907: { '2c2422': 0, '5d5351': 1 },
  910: { '161613': 0, '29251e': 1, '353434': 2 },
  912: { '101010': 0, '191711': 1, '29251d': 2 },
  913: { '4c4c4c': 0, '626262': 1 },
  915: { '740005': 0 },
  916: { '2d1b33': 0, '35213b': 1 },
  917: { '1e0a2b': 0, '411254': 1 },
  920: { '00245a': 2, '013b8d': 3, '020b1d': 0, '071326': 1 },
  921: { '023781': 1, '063272': 0 },
  922: { '7836aa': 1 },
  923: { '0f1228': 0, '1c2451': 1, '24379a': 2 },
  926: { '281731': 0, '47255c': 1, '542b6b': 2 },
  927: { '401f50': 0, '4e2764': 1, '5f2e76': 2, '7b3c94': 3 },
  930: { 'cfd1c4': 2, 'f8f8f8': 3 },
  931: { '45443c': 0, '9a9485': 1, 'a7a192': 2, 'bcb5a5': 3 },
  932: { '261f10': 0, '413116': 0, '674f2c': 1, 'c17a3b': 2, 'd1c2a5': 3, 'dc9352': 2, 'e5dec6': 3 },
  933: { 'd5c5a5': 1, 'e5dec6': 2, 'eae5d7': 3 },
  934: { '261f0f': 0, '453212': 1, '573f10': 1, '664a20': 1, '7a541e': 2, 'd3c6a9': 3, 'e5dec6': 3 },
  936: { '424247': 0, '53535a': 1 },
  940: { '2b511c': 0, '325c1e': 1 },
  941: { '314016': 0, '3a4c18': 1 },
  942: { '444443': 0, '585858': 1 },
  943: { '174115': 0, '1d4d19': 1, '276321': 2 },
  944: { '1a1b0d': 0, '222c18': 1, '254226': 1, '2a4b2b': 2, '453212': 1, '573e0d': 2, '664a20': 3, '795318': 3 },
  946: { '453212': 1, '552408': 0, '684d24': 2, 'a03405': 2, 'aa6927': 2, 'ec8834': 3 },
  947: { '30200d': 0, '453212': 1, '4f440c': 2, '532d09': 1, '5e5910': 3, '925116': 3 },
  951: { '4b4b4b': 0, '5b5c5c': 1, '6b6c6c': 2 },
  952: { '261f10': 0, '3c2f14': 1, 'd0c0a2': 3 },
  954: { '08217b': 0 },
  956: { '255ca3': 1 },
  957: { '061e83': 0, '0c2ec2': 1 },
  960: { '1f270d': 0, '243a12': 1, '38451b': 2, '4b5325': 2, '5f6834': 3 },
  961: { '4e572d': 1 },
  962: { '453014': 0, '78541f': 1, 'bbb094': 2, 'dbd2b6': 3, 'e5dec6': 3 },
  964: { '79340d': 0, 'ad430a': 1, 'cb4d08': 2, 'e07f2e': 3, 'fb9742': 3 },
  966: { '231a0f': 0, '432619': 1, '453212': 2, '9e5f1e': 3 },
  970: { '2d0f46': 0, '391759': 1 },
  971: { 'fdd207': 3 },
  972: { 'd90602': 1 },
  973: { '850e37': 0, '8c1e58': 1 },
  974: { '8e0f09': 0 },
  976: { '37190c': 0, '714b18': 3, '840402': 1, '8f0401': 2 },
  977: { '435e1f': 1, '59832c': 2 },
  1717: { '3a4914': 0 },
  1720: { '36210b': 0, '573e0d': 1, '704c1a': 3, '723d0e': 2 },
  1730: { '800d04': 0 },
  1735: { '7f0901': 0 },
  1740: { 'd0dbe0': 3 },
  1742: { '021f3b': 0 },
  1747: { '0d5e0b': 0 },
  1750: { '4c632b': 0, '556c30': 1, '5d7635': 2 },
  1751: { '282215': 0, '434343': 1, '6e6d6b': 2, '8c8c8c': 3 },
  1752: { '261f10': 0, '382716': 1, '452c15': 2, '453212': 2, '573e0d': 3 },
  1753: { '3b2c11': 0, '573e0d': 0, '774d13': 1, '9f6b12': 1, 'cc9e02': 2, 'daab01': 3, 'e2b308': 3 },
  1754: { '453212': 0, '573e0d': 1, '7a5b31': 2, 'b6935d': 3, 'd4c6a7': 3 },
  1755: { '113352': 0, '1d4b73': 1, '236295': 2 },
  1756: { '5f5b3d': 1, '8e7b55': 2, '949e84': 3 },
  1757: { '090908': 0, '101010': 1, '221e15': 2, '252525': 2, '333333': 3 },
  1758: { '18193c': 0 },
  1759: { '24092e': 0, '3d0e4b': 1, '451356': 2 },
  1760: { '452650': 0, '553263': 1 },
  1762: { '433113': 0, 'd4c6a9': 1, 'ddd3ba': 2, 'e5dec6': 3 },
  1763: { '090908': 0, '131313': 1, '282725': 2 },
  1764: { '2e4f03': 0, '52640b': 1, '528303': 2 },
  1765: { '0b0b0a': 0, 'f2efe3': 3 },
  1766: { '242017': 0, '343535': 1 },
  1767: { '494644': 0, '606370': 1, 'a0a2aa': 2, 'a5adc6': 2, 'c4cce5': 3 },
  1768: { '140805': 0, '561512': 1, '691b16': 2 },
  1769: { '494337': 0, '5c5c59': 1, 'b0aba2': 2, 'd6d4cd': 2, 'f1f0ed': 3, 'f9f9f7': 3 },
  1770: { 'dacaa6': 2, 'e5dec6': 3 },
  1771: { '080d15': 0, '0d1623': 1, '121c2c': 2 },
  1772: { '1e1b1d': 0, '6a574e': 1, '828185': 2 },
  1773: { '151540': 0, '1d1c4c': 1 },
  1774: { 'b50301': 1 },
  1775: { '090908': 0, '141311': 1, '262015': 2, '302e28': 2, '49463e': 3, '5a564a': 3 },
  1776: { '1e391b': 1, '222511': 0, '254322': 2, '2a4b27': 3 },
  1777: { 'd9cfb6': 2, 'e5dec6': 3 },
  1778: { '483211': 0, '573e0d': 0, '824515': 1, 'ab6724': 2, 'dcbd84': 3, 'e4dcc3': 3 },
  1779: { '2b1e0c': 0, '453212': 1, '573e0d': 1, '5c3710': 1, '774d13': 2, 'b36927': 3 },
  1780: { '0d0c0b': 0, '1c1d1c': 1, '252119': 2 },
  1781: { '1a1206': 0, '281e0b': 1, '39290a': 1, '463212': 2, '4d3a17': 2, '573e0d': 2, '674b21': 2, 'a56321': 3 },
  1782: { '0b0b0a': 0, '272118': 1, '363333': 2, '3e3a38': 2, '4a4545': 2, '685950': 3 },
  1783: { '5f0d0d': 0 },
  1784: { '353421': 0, '3b422f': 1, '525b44': 2 },
  1785: { '423a25': 1, '453212': 0, '4e452e': 2, '6b4a1e': 3, '7d5117': 3 },
  1786: { '3b4730': 0, '4c5b41': 1, '55644a': 2 },
  1789: { '261f10': 0, '2c2b17': 1, '383c25': 2, '42452c': 2, '463211': 2, '695123': 3 },
  1790: { 'b4aa98': 1, 'cdc3b3': 2, 'e4ddcf': 3 },
  1791: { '251d0e': 0, '4f330f': 1, '573e0d': 1, '774d13': 1, 'a95916': 2, 'dfd1af': 3, 'e5dec6': 3 },
  1792: { '0c0b0a': 0, '282216': 1, '3b342f': 2, '474039': 3 },
  1793: { '13230b': 0, '164611': 1 },
  1794: { '0c0b08': 0, '211b10': 1, '3c3c3c': 2, '444545': 3 },
  1795: { '4d2708': 0, '67350d': 1 },
  1796: { '201b0f': 0, '453212': 1, '573e0d': 1, '865616': 2, 'b2691f': 2, 'c37c2b': 2, 'e88827': 3, 'fb9742': 3 },
  1797: { '390706': 0, '540d0d': 1, '6b0d0e': 2, 'a61313': 3 },
  1798: { '4c4e37': 0, '717351': 1 },
  1799: { '473312': 0, '573e0d': 0, '664a20': 1, '7e541c': 1, 'ac8747': 2, 'c49b4e': 3, 'd3ac59': 3 },
  1800: { '261b0d': 0, '453212': 1, '6b2501': 2, '7d531b': 3, '9c3702': 3 },
  1802: { '711005': 0, '94190a': 1 },
  1803: { '261f10': 0, '4b3513': 1, '573e0d': 1, '7d460a': 2, '865110': 2, 'cf7c22': 3, 'd6a134': 3 },
  1805: { '28231a': 0, '2c2c2b': 1, '37332f': 2 },
  1807: { '1e1a0e': 0, '212611': 1, '3b4320': 2, '3d3214': 2, '5b5b40': 3 },
  1809: { '1e4059': 0, '2b5778': 1 },
  1811: { '222b0e': 0, '2c3913': 1, '6fa324': 2 },
  1815: { '9d0c02': 1 },
  1816: { '522212': 0, '8f391e': 1, 'c32a20': 2 },
  1820: { '185948': 0, '27705a': 1, '81b2a1': 3 },
  1829: { '2f1e0c': 0, '463111': 1, '7e4a16': 2 },
  1834: { '840102': 0 },
  1835: { '453315': 1, '4e2c11': 0, '513e1b': 2, 'e0802f': 3 },
  1839: { '4a3311': 0, '573e0d': 1, '7e5116': 2, 'a57849': 2, 'ded4b9': 3 },
  1844: { '303041': 0, '3f447f': 2, '453212': 1, '675334': 2, 'ad8464': 3 },
  1851: { 'ececed': 3 },
  1852: { '065aba': 1 },
  1856: { '415323': 0, '6b8056': 2 },
  1857: { '803d25': 1, 'c46c37': 2 },
  1863: { '272010': 0, '453212': 1, '523612': 1, '573e0d': 1, '664a20': 2, '6d4618': 2, '764f1a': 2, 'b57d4e': 3 },
  1865: { '145b6a': 1 },
  1866: { '660504': 0, '860d0c': 1, 'b1411e': 2 },
  1869: { '63390d': 0, '6a4a1e': 1, '815422': 2, '9a7954': 3, 'cb792f': 3 },
  1871: { '714c84': 1 },
  1873: { 'a62a1b': 1 },
  1875: { '024a9d': 1 },
  1876: { '1b5c9c': 0, '1c64ab': 1 },
  1879: { 'dbd3be': 2, 'ede8dd': 3 },
  1884: { 'c80f02': 1 },
  1886: { '085aa7': 1 },
  1887: { 'd4bf95': 2, 'e5dec6': 3 },
  1893: { '465030': 0 },
  1894: { '1e4514': 0, '244f18': 1 },
  1895: { '224f7a': 0 },
  1897: { 'b95d45': 2 },
  1898: { 'd2c8b2': 2, 'ddd4c1': 3 },
  1899: { 'd0c6b0': 2, 'e3e3e3': 3 },
  1902: { '02308c': 0, '0852da': 1 },
  1903: { '9c550c': 1, 'f97a03': 3 },
  1904: { '138435': 1 },
  1906: { '034dcc': 1, '035be5': 2 },
  1909: { '95521b': 1, 'a35b1d': 2 },
  1911: { 'd3bfa1': 2, 'f2eddd': 3 },
  1915: { 'cd2013': 1 },
  1923: { '535352': 0, '616161': 1, '737373': 2, 'b0aba1': 3 },
  1927: { '2a1e10': 0, '402615': 1, '4b321b': 1, '5c3721': 2, '6a3e26': 2, 'ab6d31': 3, 'ed974d': 3 },
  1929: { '8ab1e5': 1, '9bd3fd': 2, 'aedcfc': 3 },
  1930: { '140706': 0, '8a0202': 1, 'b00404': 2 },
  1933: { '5b6046': 0, '6f6a46': 1, '828a6c': 2 },
  1934: { '051204': 0, '1e5b2e': 1, '3d731a': 2 },
  1935: { '061b69': 0, '0b2176': 1 },
  1936: { '29241e': 0, '2f2b26': 1, '38322d': 2, '443d34': 3 },
  1938: { 'bfb08f': 1, 'd1c1a3': 2, 'e5dec6': 3 },
  1939: { '0d0c0b': 0, '1d1d1d': 1 },
  1940: { '090908': 0, '1a1d1a': 1 },
  1941: { '0438a0': 0, '064acc': 1 },
  1944: { '939393': 2, 'fefefe': 3 },
  1946: { 'ededed': 2, 'fafbfb': 3 },
  1948: { '101010': 0, '1f1c17': 1, '242324': 2 },
  1949: { '49545f': 0, '5c6975': 1, '807466': 2 },
  1951: { '131b2d': 0, '1c2946': 1 },
  1953: { '5478c7': 1, '8190b9': 2 },
  1954: { '172c23': 0, '193326': 1 },
  1957: { '221e14': 0, '292929': 1, '949393': 2 },
  1958: { '0c0b0a': 0, '3e3c38': 1, '57544d': 2, 'afa69e': 3, 'd4c6b4': 3 },
  1959: { '090908': 0, '111111': 1, '251f13': 2, '4e4637': 3 },
  1961: { '1a1020': 0, '3b2140': 1, '6b3395': 2 },
  1964: { '7c0d0f': 0, 'c61215': 1 },
  1973: { 'f7f4ea': 3 },
  1983: { 'be0705': 1 },
  1985: { '3d1a0c': 0, 'd41008': 1 },
  1988: { '4f0101': 0, '9c0805': 1, 'c62511': 2 },
  1989: { '0f1f30': 0, '1870bf': 2, '364f66': 1 },
  1990: { '210b0a': 0, 'a00d04': 1 },
  1996: { '960001': 0, 'd00102': 1 },
  1998: { '41110f': 0, '591a13': 1, 'b61411': 2, 'b71916': 3 },
  2000: { '24412c': 0, '2d5335': 1 },
  2001: { '434343': 0, '5a5a5a': 1, '767676': 2 },
  2002: { '443314': 0, '573e0d': 1, '664a20': 1, '76511c': 1, 'af884f': 2, 'cbae74': 2, 'e5dec6': 3, 'ebca88': 3 },
  2003: { '0c0c0b': 0, '242018': 1, '35322f': 2, '3f3b38': 2, '4a4642': 3 },
  2004: { '0a0908': 0, '1e1a12': 1, '282b30': 2, 'af8649': 3, 'e0d8be': 3 },
  2005: { '0d161e': 0, '1d2f43': 1, '253b53': 2 },
  2006: { '231c0f': 0, '453212': 1, '664a20': 2, '6f5a3d': 2, 'bca785': 3, 'bd7c3f': 3 },
  2007: { '372a11': 0, '644113': 0, 'ae6f17': 1, 'c2b190': 2, 'de802a': 2, 'ded5bd': 3, 'e5dec6': 3 },
  2008: { '090908': 0, '151413': 1, '333433': 2, 'b5afa1': 3 },
  2009: { '0c0c0b': 0, '1c1b1c': 1 },
  2010: { '0c0b0a': 0, '45433c': 1, '716b5e': 2, 'e8e2cd': 3 },
  2011: { '261f10': 0, '34230d': 0, '453212': 1, '5b3c19': 2, '684a1f': 2, '83541a': 2, 'e1d9bf': 3 },
  2012: { '664a20': 0, '774f17': 1, 'c1af86': 2, 'd7cbad': 3, 'e5dec6': 3 },
  2013: { '37566c': 1, 'c7b084': 2, 'e6e1b5': 3 },
  2014: { '593f0e': 0, '5d2311': 0, '77511b': 1, 'bd9044': 2, 'd61f19': 1, 'f18530': 2, 'fb9742': 3 },
  2016: { '231e0d': 0, '253111': 1, '393913': 1, '3f4b15': 2, '4a5415': 2, '565e16': 2, '6e4b1a': 2, '8e6f1f': 3 },
  2017: { '040d02': 0, '10170b': 1, '1b2812': 2, '223317': 2, '2f421d': 3 },
  2018: { '130403': 0, '190101': 1, '2b130a': 2, '6e1208': 2, 'aa2b14': 3 },
  2019: { 'c1d1dd': 3 },
  2020: { '2a2010': 0, '473112': 1, '593f0f': 1, '664a21': 1, '7e5119': 1, 'b8732e': 2, 'ccb995': 3, 'ce9962': 2, 'e5dec6': 3 },
  2021: { '30170c': 0, '5c100c': 1, '9b160f': 2, '9f430f': 2, 'e56c12': 3 },
  2022: { '221c0f': 0, '483311': 1, '573e0d': 1, '7b4e17': 2, 'bb7c3b': 3, 'bd742f': 3 },
  2023: { '2f210c': 0, '4b330f': 1, '573e0d': 1, '5f3c0c': 1, '694718': 2, '6e532f': 2, '774d13': 2, 'c67a37': 2, 'e5ddc6': 3 },
  2024: { '14190d': 0, '242512': 0, '37421a': 1, '3a3213': 1, '4c5b21': 2, '573e0d': 1, '607128': 2, '6f4b1a': 2, 'c17e2d': 2, 'ded7ba': 3 },
  2025: { '0b0b0b': 0, '221e14': 1, '242424': 2 },
  2026: { '4d4d4d': 0, '5b5b5b': 1, '747474': 2 },
  2027: { '4b6218': 1 },
  2028: { '352912': 0, '403821': 1, '4d4124': 1, '573e0d': 1, '5b4b24': 2, '655126': 2, '6c4b1b': 2, 'ca792f': 3, 'e2d6b3': 3, 'f38731': 3, 'fb9742': 3 },
  2030: { '0b0b0a': 0, '282317': 1, '4d4d4c': 2, '5f5f5f': 3, '776f63': 3 },
  2031: { '0c0c0b': 0, '262219': 1, '464f5c': 2, '5a6474': 3 },
  2032: { '32170c': 0, '850201': 1 },
  2033: { '0b0b0b': 0, '191713': 1, '2a2723': 2, '38342f': 3 },
  2034: { '4b1c54': 0, '581c60': 1 },
  2035: { '2b1c0e': 0, '312311': 1, '4a3213': 2 },
  2036: { '015357': 0, '017d7a': 1, '55977b': 2 },
  2037: { '473519': 0, '593f0e': 1, '9b8f76': 2, 'b9ac92': 3 },
  2038: { '6a0000': 0, '8c0101': 1, 'a20101': 2 },
  2039: { '262010': 0, '383413': 1, '5c5a17': 2, '708b1e': 2, 'c3bc7a': 3 },
  2040: { '552c10': 0, '664a1f': 1, '84521a': 1, 'ccb58a': 3, 'cfc7ad': 3, 'd1833a': 2, 'fb9742': 3 },
  2041: { '150908': 0, '860201': 1, 'dc0c02': 2 },
  2042: { '0a0908': 0, '101010': 1, '211e15': 2, '242524': 3 },
  2043: { '261f10': 0, '443112': 1, '661700': 1, '68481d': 3, '70310a': 2, '7c1d00': 2 },
  2044: { '2a2111': 0, '423218': 1, '4d3f2b': 1, '5f4e37': 2, '774d13': 2, '7b6243': 2, 'dd812f': 3, 'e1d8be': 3 },
  2045: { '441750': 0, '4b1a58': 1, '612071': 2 },
  2046: { '090908': 0, '101010': 1, '221e14': 2 },
  2047: { '17091a': 0, '410f4e': 1 },
  2048: { '365168': 0, '526675': 1, '94a3af': 2, 'c3c2bb': 3, 'e8e3d4': 3 },
  2049: { '2a200f': 0, '4e310f': 1, '573e0d': 1, '7b420d': 2, '7d4e13': 2, 'c7781d': 3, 'e2d5b2': 3, 'e99d09': 3 },
  2050: { '03124b': 1, '05091b': 0 },
  2051: { '0b1f08': 0, '246305': 1, '399b03': 2, '6eb42a': 3 },
  2052: { '82796a': 1, 'b3ac99': 2, 'cfc8b5': 3 },
  2053: { '120908': 0, '6b0201': 1, 'a40101': 2 },
  2054: { '19130a': 0, '271e0e': 0, '39270d': 1, '493311': 1, '573e0d': 1, '67491f': 2, '7a4e13': 2, 'dd812c': 3, 'e2b24f': 3, 'e5dec6': 3, 'fb9742': 3 },
  2055: { '422917': 0, '673e25': 1, '6c4a23': 2 },
  2056: { '090908': 0, '101010': 1, '222221': 2 },
  2057: { '271f10': 0, '664a20': 1, '7f541e': 2, 'c87a34': 3, 'fb9742': 3 },
  2059: { '090908': 0, '101010': 1, '1d1d1b': 2 },
  2060: { '164513': 0 },
  2061: { 'dcdcdb': 2, 'ececec': 3 },
  2062: { '015d1d': 0 },
  2063: { '391b0e': 0, '573e0d': 1, '774d13': 1, 'a00505': 1, 'c88246': 2, 'd0c0a2': 3, 'fb9742': 3 },
  2064: { 'ccc1a9': 1, 'e5dec6': 2, 'efeee3': 3 },
  2065: { '2d130b': 0, '4a090b': 1, '7e1617': 2 },
  2066: { '385265': 1, '9db3c3': 3 },
  2067: { '090908': 0, '141414': 1, '272217': 2, '403f3c': 3 },
  2068: { '4d3210': 0, '573e0d': 1, '674920': 2, 'b78d6b': 3 },
  2069: { '090908': 0, '111111': 1, '262014': 1, '535864': 2, 'cbc1ae': 3, 'f7f9fb': 3 },
  2071: { '463110': 0, '55400d': 1, '9e6117': 2, 'f38731': 3 },
  2072: { '0a0d15': 0, '0b2561': 1, '463212': 1, '6d5432': 2, 'e5dec6': 3 },
  2073: { '261f10': 0, '573e0d': 2, '72100e': 1 },
  2075: { '090908': 0, '101010': 1, '232015': 2 },
  2077: { '163254': 0 },
  2078: { '382209': 0, '673503': 1, 'dc7e2f': 2 },
  2079: { '090908': 0, '131313': 1, '262116': 2, '363431': 3 },
  2080: { '090908': 0, '191919': 1, '2a2929': 2 },
  2081: { '1c6706': 1 },
  2082: { '483312': 0, '573e0d': 1, '774c14': 2 },
  2083: { '6d0101': 0 },
  2086: { '090908': 0, '131313': 1, '242424': 2, '2c2a28': 3 },
  2087: { '210202': 0, 'a30101': 1 },
  2090: { '0b0b0a': 0, '1c1c1c': 1, '26221a': 2 },
  2091: { '090908': 0, '101010': 1, '252014': 2, '646362': 3 },
  2092: { '6c6c6c': 1, 'fafafa': 3 },
  2096: { '090908': 0, '101010': 1, '1f1f1e': 2 },
  2097: { '3f331e': 0, '6d583b': 1, 'ba8253': 2 },
  2098: { '990101': 1 },
  2099: { 'cdc7ad': 1, 'e5dec6': 2, 'efefee': 3 },
  2101: { 'dc0a03': 2 },
  2102: { '090908': 0, '101010': 1, '27221b': 2 },
  2105: { '702d06': 0, '98400c': 1 },
  2106: { '171817': 0 },
  2107: { '0a0a08': 0, '444444': 1 },
  2108: { '282010': 0, '503310': 1, '573e0d': 2, '774d13': 3, '834511': 3 },
  2110: { '191919': 0, '6a6a6a': 1 },
  2111: { '0c0b09': 0, '261f10': 1, '3a2f1d': 2, '434343': 3 },
  2112: { 'a60b05': 1 },
  2113: { '090908': 0, 'a8a8a8': 3 },
  2114: { '617434': 1 },
  2115: { '566553': 1 },
  2116: { '090908': 0, '171717': 1, '272219': 2 },
  2117: { '0f0f0e': 0, '252014': 1 },
  2118: { '0a0a09': 0, '211e12': 1, '2b2c2b': 1, '3d321f': 2, '3d3d32': 2, '573e0d': 2, '715a10': 3 },
  2119: { '0b0b09': 0, 'e8e6da': 3 },
  2120: { '344315': 0, '516722': 1 },
  2121: { '261f11': 0, '443316': 1, '573e0d': 2, '624a27': 2, '775320': 2, '93714b': 3 },
  2122: { '281f10': 0, '553116': 1, '664a20': 2, '854721': 3 },
  2123: { '090908': 0, '928c7c': 1, 'b7b09d': 2, 'fbfbfa': 3 },
  2124: { '040b04': 0, '051d07': 1, '0c3a0e': 2, '144616': 3 },
  2125: { '2c607b': 1, '4bb3e0': 3 },
  2126: { '2a3e19': 0, '344c20': 1 },
  2127: { '140402': 0, '490a08': 1, '8f1c17': 2 },
  2128: { '151515': 0, '272115': 1, '3a3122': 2, '474847': 3 },
  2129: { '261f10': 0, '3e2d12': 1, '534331': 2, '765221': 2, 'bf7b41': 3 },
  2130: { 'a12219': 1 },
  2132: { '0a0908': 0, '161511': 1, '252119': 2 },
  2133: { '261f10': 0, '3b301e': 1, 'be916d': 2 },
  2135: { 'f9d306': 2, 'fdf4cb': 3 },
  2136: { '0a0a0a': 0, '262218': 1, '363636': 3, '372f21': 2 },
  2137: { 'a71608': 1 },
  2138: { 'bbdffd': 3 },
  2140: { '352811': 0, '80561b': 1, 'bd8a43': 2 },
  2141: { '3f3624': 0, 'bd8e60': 2, 'd1c4a8': 3 },
  2142: { '1a6658': 1 },
  2143: { '352912': 0, '573e0d': 1, '664a20': 2, '918a6e': 3, 'c0b495': 3 },
  2145: { '090908': 0, '161209': 1, 'a4a4a4': 2, 'bcb7ae': 3 },
  2146: { '4c6308': 1, '8e9d41': 2 },
  2147: { '392b11': 0, '664a20': 1, 'e2802f': 2, 'fb9742': 3 },
  2148: { '0b0b0b': 0, '1b1c1b': 1, '232323': 2, '2b2b2b': 3 },
  2150: { '4a0000': 0, 'ca0801': 1 },
  2151: { '241e10': 0, '443316': 0, '664a20': 1, '774d13': 1, 'a05f26': 1, 'd1b690': 2, 'd3c2a4': 2, 'd98137': 2, 'e5dec6': 3, 'fb9742': 2 },
  2152: { 'd50905': 1 },
  2154: { '0a0a09': 0, '444443': 1 },
  2155: { '754d15': 0, '7e643a': 1, 'c8a260': 3, 'ec8b3a': 2 },
  2156: { '0a1607': 0, '0b2104': 1, '102d09': 2, '1c3d14': 3 },
  2157: { '090908': 0, '141514': 1, '272216': 2 },
  2160: { 'cdbe9f': 1, 'dcd3b9': 2, 'e5dec6': 3 },
  2161: { '1a4a18': 0, '2e7025': 1 },
  2162: { '090908': 0, '101010': 1 },
  2163: { 'aa966a': 0, 'cfbf9b': 1, 'dacda5': 2, 'e5dec6': 3 },
  2164: { 'b40301': 1 },
  2165: { '090908': 0, '1c242e': 1, '505e63': 2, '687e84': 3 },
  2166: { '0b5283': 0, '0b64a0': 1 },
  2167: { '1b1b0e': 0, '334422': 2, '343618': 1 },
  2168: { '0a0b09': 0, '212115': 1, '343322': 2, '3f4e45': 2, '606654': 3 },
  2170: { '273d21': 0 },
  2171: { '730202': 0, 'dd0405': 2 },
  2172: { '463214': 0, '573e0d': 1, '68563b': 2, '774d13': 2, '87765f': 3, 'd17a2c': 3 },
  2173: { '090908': 0, '1c1912': 1 },
  2174: { '587989': 1, 'c9e5f3': 3 },
  2175: { '090908': 0, '1d1d1d': 1 },
  2176: { '504a42': 0, '625f5b': 1, '706e6b': 2 },
  2178: { 'd0c0a2': 1, 'd5caac': 2, 'e5dec6': 3 },
  2179: { '20250f': 0, '244818': 1, '2f531c': 2 },
  2180: { '0a0a09': 0, '171615': 1, '211f18': 2 },
  2181: { '434b4b': 0, 'a9bec8': 3 },
  2182: { '090908': 0, '101010': 1, '211d14': 2 },
  2183: { '342711': 0, 'cc7d30': 1, 'd3b16b': 2, 'f3c764': 3 },
  2186: { '53504b': 0, '616161': 1, 'b4b4b3': 2, 'cac2b4': 3 },
  2189: { '090908': 0, '161615': 1, '272115': 2, '544e42': 3 },
  2190: { '451c62': 0 },
  2191: { '830b0b': 0, '9b0e0e': 1, 'b61212': 2 },
  2193: { '090908': 0, '10100f': 1, 'a3a2a2': 3 },
  2195: { '9b1002': 1 },
  2196: { '090908': 0, '929292': 1, 'cbc1af': 2, 'd3d2d2': 2, 'f8f8f8': 3 },
  2197: { '090908': 0, '14101c': 1, '261d1c': 2, '4a323c': 3 },
  2198: { 'eceded': 3 },
  2199: { '2b340f': 0, '2e4a17': 1, '73ab3b': 2 },
  2200: { '2d210e': 0, '453212': 1, '573e0d': 1, '634014': 1, '7a4e14': 2, 'ca7a2e': 3, 'e58733': 3 },
  2201: { '880c03': 0 },
  2203: { '533510': 1, '542503': 0, '573e0d': 1, '88561c': 2, 'df7f2f': 3 },
  2204: { '090908': 0, '092d53': 2, '0c141c': 1, '303b43': 3 },
  2205: { '3a1f10': 0, 'f80301': 2 },
  2208: { '0a0703': 0, '0b0a07': 1, '1f190e': 2, '453212': 3 },
  2216: { 'bb8e02': 1, 'dbac02': 2, 'e5dec6': 3 },
  2217: { '7b1109': 0 },
  2218: { '3f190c': 0, 'bd0201': 1 },
  2220: { '070a04': 0, '090908': 1, '1d1910': 2, '214003': 3 },
  2223: { '130502': 0, '2f200f': 0, '50411c': 1, '642f31': 1, '664a20': 3, '683a16': 2, '774d13': 3 },
  2224: { '2a2a2a': 0, '4d4d4c': 1 },
  2225: { '090908': 0, '111110': 0, '3a2b11': 1, 'bfb9a8': 2, 'd3c6ae': 2, 'e5dec6': 2, 'fefefe': 3 },
  2226: { '6e0fa3': 1 },
  2229: { '3d170b': 0, '5c0101': 1, '664a20': 2, 'dc7f31': 3 },
  2231: { '102404': 0, '27630a': 1 },
  2232: { '493111': 0, '573e0d': 1, '7b4e13': 2, 'd47b2e': 3, 'fb9742': 3 },
  2233: { '2e1f0c': 0, '4b2e0c': 1, '664a20': 2 },
  2234: { '2d220f': 0, '473313': 1 },
  2236: { '130404': 0, '3a1e13': 1, '8c141f': 2 },
  2237: { '1e120b': 0, '492f0f': 1, '664a20': 2 },
  2239: { '090908': 0, '10100f': 1, '231e14': 2 },
  2241: { '125ac2': 1 },
  2245: { '09360a': 0, '0c6f18': 2, '704c18': 1, 'cb6d24': 3 },
  2246: { '090908': 0, '101010': 1 },
  2247: { '090908': 0, 'cdc8be': 2, 'ebecec': 3 },
  2248: { '750703': 0 },
  3423: { '1e1b18': 0, '2a2215': 1, '353029': 2 },
  3424: { '15225e': 1, '1e2030': 0 },
  3434: { '261e0e': 0, '463313': 1, '573e0d': 1, '664a20': 1, '835920': 1, 'c8833d': 2, 'cfb688': 3, 'e9cb94': 3, 'ebd3a3': 3 },
  3437: { '0b0a09': 0, '292316': 1, '474747': 2 },
  3441: { '3f1542': 0, '5a235c': 1 },
  3443: { '710001': 0, '860101': 1, 'c00101': 2 },
  3444: { '040a05': 0, '23632c': 1 },
  3446: { '073012': 0, '104e1d': 1 },
  3447: { '0b0b0a': 0, '161716': 1, '7b0101': 2 },
  3448: { '3c1c0f': 0, '453212': 1, '851511': 2, 'c21713': 3 },
  3449: { 'e4e3db': 3 },
  3450: { '394459': 0 },
  3451: { '362911': 0, '664a20': 1, '906722': 1, 'cba54f': 2, 'd27a2c': 2, 'd68930': 2, 'e3dbc3': 3, 'e9bf51': 3 },
  3452: { '150224': 0, '1f0132': 1, '26003c': 2, '740cc7': 3 },
  3453: { '563e0f': 1, '5c4a2c': 2, '695a3f': 2, '6e240d': 0, 'd6b993': 3 },
  3454: { '0e0714': 0, '55197f': 1 },
  3457: { '090908': 0, 'c6c1a4': 1, 'e5dec6': 2, 'f3f2ec': 3 },
  3459: { '185b2a': 0 },
  3460: { '2a1708': 0, '312a10': 1, '674a1f': 2, '845119': 2, 'd37d34': 3 },
  3461: { '372a11': 0, 'd1c2a6': 2, 'e5dec6': 3 },
  3462: { '171208': 0, '261f10': 1, '443011': 2, '573e0d': 3, '6a421a': 3 },
  3463: { '52652c': 1 },
  3465: { '4b5335': 1 },
  3466: { 'e60704': 2 },
  3470: { '1b2a4a': 0, '223357': 1 },
  3471: { '737373': 1, '949494': 2 },
  3472: { '232323': 0 },
  3475: { '3a240b': 0, '493312': 1, '573e0d': 2, '6f4c19': 3 },
  3477: { 'a50101': 1 },
  3478: { '47311a': 0, '885b13': 1, 'cb9411': 2, 'dc7c2d': 2, 'dcb754': 3 },
  4011: { '6a0302': 0 },
  4022: { '0c0c0a': 0, '601e0e': 1, '9daaa4': 3 },
  4031: { '011975': 0, '0225aa': 2, '0b2282': 1 },
  4032: { '1e355b': 0, '2f4c82': 1, '3c5a8e': 2 },
  4041: { '0a0e08': 0, '23290e': 1, '26440f': 2, '345512': 3, '416615': 3 },
  4042: { '261f10': 0, '453212': 1 },
  4043: { '2c2311': 0, '453212': 1, '573e0d': 2, '593a1b': 2, '664a20': 3 },
  4051: { 'f5f0e3': 3 },
  4062: { '0e070e': 0, '380b34': 1, '530d43': 2 },
  4081: { '21190c': 0, '443212': 1, '5a411d': 1, '754f1a': 2, 'cda85f': 3, 'e5dec6': 3 },
  4082: { 'd9c799': 2, 'e9ddb5': 3 },
  4091: { '204c5b': 0, '2f677a': 1, '3f798c': 2 },
  4103: { '3d210d': 1, '3e1a06': 0, '463213': 2, '654b26': 2, 'de7f2e': 3 },
  4107: { '272010': 0, '453212': 0, '533e16': 1, '664d27': 1, '7f5925': 1, 'b5a98f': 2, 'd5c7ac': 3, 'de7e2f': 2, 'e5dec6': 3 },
  4108: { '4f6e73': 1, '8eaaaf': 3 },
  4110: { '2f290f': 0, '414312': 1, '4c3111': 1, '573e0d': 1, '574b18': 2, '6d622a': 3, '784d14': 3 },
  4111: { '050e07': 0, '0f250d': 1, '616713': 2, 'aeaf52': 3 },
  4118: { '3e1a0e': 0, 'ac1113': 1 },
  4122: { '090908': 0, '121212': 1, '262119': 2, '2b292c': 3 },
  4126: { '0e0f20': 0, '131959': 1 },
  4127: { '0a0e14': 0, '0b2348': 1, '202221': 1, '5a616d': 2, 'ded7c2': 3 },
  4201: { '090908': 0, '101010': 1, '1f1913': 2, '29221a': 2, '41331b': 3, '474747': 3 },
  4202: { '0d0d0c': 0, '353535': 1, '3c3c3b': 2, '464645': 3 },
  4203: { '0b0b0a': 0, '1c1c1b': 1, '232423': 2 },
  4211: { '16274c': 0, '4671be': 1, '77a4e8': 3 },
  4212: { '0a2644': 1, '1b2c35': 2, '221d12': 0 },
  4230: { 'bfd973': 3 },
  4231: { '3768a3': 1, '528fda': 2, '8baed4': 3 },
  4243: { '244229': 0 },
  4262: { '031d5b': 1, '090d1a': 0 },
  4271: { '6b0703': 0, '970c06': 1 },
  4272: { '090908': 0, '101010': 1, '20201f': 2, '302112': 2, '40331e': 2, '6e4d1f': 3 },
  4281: { '453314': 0, '55370f': 0, '645134': 1, '774d13': 1, '91826f': 2, 'd7c9ac': 3 },
  4282: { '0a0908': 0, '14110a': 1, '362911': 2, '774d13': 2, 'fdfdfc': 3 },
  4290: { '02722d': 1 },
  4303: { '0a0a09': 0, '4e5358': 1 },
  4311: { '4e4839': 0, '847e6d': 2 },
  4313: { '30170b': 0 },
  4314: { '090908': 0, '1c1a15': 1, '242423': 2, '30302f': 2, '545454': 3 },
  4315: { '090908': 0, '101010': 1, '23211c': 2, '313131': 3 },
  4316: { '090908': 0, '121212': 1, '272114': 2, '545454': 3 },
  4319: { '0d0c0a': 0, '4d4643': 1, '6e6560': 2 },
  4320: { '7c7c7c': 2, 'dad7cc': 3 },
  4323: { '402e16': 0, '4b3f2b': 1, '6a4d23': 2 },
  4324: { '291e0f': 0, '4c3212': 1, '704c18': 2, 'bc7321': 3 },
  4325: { '261f10': 0, '654a21': 1, '774d13': 1, '9d803b': 2, 'ccaf62': 2, 'd4842d': 2, 'e6cb76': 3 },
  4326: { '352811': 0, 'debb7c': 1, 'f2cd8b': 2, 'fefefe': 3 },
  4327: { '613f0d': 0, '684b21': 0, 'a59677': 1, 'bdaf91': 2, 'd0c0a2': 2, 'e5dec6': 3, 'f4f2e7': 3 },
  4329: { '250d0d': 0, '7e1011': 1 },
  4333: { '262c93': 0 },
  4335: { '613417': 0, '8b4422': 1 },
  4401: { '493011': 0, '523913': 0, '892201': 1, 'b83101': 2, 'd36817': 2, 'd43e01': 2, 'e5842a': 3, 'fb9742': 3 },
  4402: { '0b0b0a': 0, '79756d': 2, '821a02': 1 },
  4417: { 'c9a559': 0, 'd6c6a4': 1, 'e0c06e': 1, 'e1d7b9': 2, 'ece7d8': 3, 'f2f1ee': 3 },
  4424: { '334314': 0, '909e3c': 2 },
  4428: { '243311': 0, '324718': 1 },
  4429: { '090908': 0, '544d40': 1 },
  4437: { '332710': 0, '635a17': 1, 'b88b1a': 2 },
};
